// extracted by mini-css-extract-plugin
export default {"MONTH":"a8Z1Rq","month":"a8Z1Rq","DAY":"NIKJK6","day":"NIKJK6","YEAR":"E_VwOH","year":"E_VwOH","fields":"FpHeWU","mobile":"TRFcfF"};